if (document.querySelector(".header__filters--all-categories")) {
  const buttonOpenAllCats = document.querySelector(
      ".header__filters--all-categories"
    ),
    body = document.body,
    allCategories = document.querySelector(".all-categories"),
    closeAllCategories = document.querySelector(".all-categories__close"),
    megaMenus = document.querySelectorAll(".all-categories__nav--medium--li");

  buttonOpenAllCats.addEventListener("click", () => {
    allCategories?.classList.add("isOpen");
    body.classList.add("hidden");
  });

  closeAllCategories?.addEventListener("click", () => {
    allCategories?.classList.remove("isOpen");
    body.classList.remove("hidden");
  });

  megaMenus.forEach((megaMenu) => {
    const menuListClose = megaMenu.querySelector(
      ".all-categories__nav--medium--close"
    );

    megaMenu.addEventListener("click", () => {
      megaMenus.forEach((li) => li.classList.remove("open"));
      megaMenu.classList.add("open");
    });

    menuListClose?.addEventListener("click", (event) => {
      event.stopPropagation();
      megaMenu.classList.remove("open");
    });
  });
}
